import React from 'react';

import { useConversionTable } from 'hooks';
import { formatDate } from 'utils/date';

import { useCXIMentoring } from '../../useCXIMentoring';

import * as Styled from './StyledEvaluations';

export const EvaluationsEvaluation = ({ evaluation }) => {
    const { t, vars } = useCXIMentoring();
    const { sessions } = vars;
    const session = sessions.find(s => s._id === evaluation.mentoringSessionId);

    const conv = useConversionTable(['contributionTheme']);

    let theme = t('mentoring.Evaluations.noTheme');
    if (evaluation.theme) {
        theme = conv.contributionTheme[evaluation.theme];
    } else if (evaluation.cxiStage === 3) {
        theme = t('mentoring.Evaluations.theme.contribution');
    } else if (evaluation.cxiStage === 2) {
        theme = t('mentoring.Evaluations.theme.feedback');
    } else if (evaluation.cxiStage === 1) {
        theme = t('mentoring.Evaluations.theme.evaluation');
    }

    let date = t(`mentoring.Evaluations.date`, {
        date: formatDate(new Date(evaluation.regDate), "dd/MM/yyyy, 'às' H'h'mm"),
    });
    if (evaluation.mentoringSessionId && session && session.meetingDate) {
        date = t(`mentoring.Evaluations.sessionDate`, {
            date: formatDate(new Date(session.meetingDate), 'dd/MM/yyyy'),
        });
    }

    let icon = '';
    let text = '';

    if (evaluation?.startupFeedback === 'positive') {
        icon = 'fa-laugh';
        text = t('mentoring.Evaluations.startupFeedback.positive');
    } else if (evaluation?.startupFeedback === 'neutral') {
        icon = 'fa-meh';
        text = t('mentoring.Evaluations.startupFeedback.neutral');
    } else if (evaluation?.startupFeedback === 'negative') {
        icon = 'fa-frown';
        text = t('mentoring.Evaluations.startupFeedback.negative');
    }

    return (
        <Styled.Evaluation>
            <Styled.EvaluationInfo>
                {!!theme && <span className="theme">{theme}</span>}
                {!!evaluation.question && <span className="question">{evaluation.question}</span>}
            </Styled.EvaluationInfo>
            <Styled.EvaluationText>&quot;{evaluation.comment}&quot;</Styled.EvaluationText>
            <Styled.EvaluationFooter>
                <span className="date">{date}</span>

                {!icon && !text ? (
                    <span className="text">{t('modal.Evaluations.startupFeedback.pending')}</span>
                ) : (
                    <span className="text">
                        Classificado como: <strong>{text}</strong>
                        <span className={`icon far ${icon}`} aria-hidden="true" />
                    </span>
                )}
            </Styled.EvaluationFooter>
        </Styled.Evaluation>
    );
};
